export enum SEX {
  MALE = 'M',
  FEMALE = 'F',
}
